import React from "react";
import { MdElectricBolt } from "react-icons/md";

interface BatteryProps {
  currentEnergy: number | string;
  maxEnergy: number | string;
  showTooltip?: boolean;
}

const Battery: React.FC<BatteryProps> = ({
  currentEnergy,
  maxEnergy,
  showTooltip = true, 
}) => {
  const currentEnergyNumber = Math.round(Number(currentEnergy));
  const maxEnergyNumber = Math.round(Number(maxEnergy));

  const percentage =
    maxEnergyNumber > 0
      ? Math.min(100, Math.round((currentEnergyNumber / maxEnergyNumber) * 100))
      : 0;

  return (
    <div className="flex items-center border-2 border-[#c3c8cf] rounded-md w-[130px] h-[30px] p-[2px] mr-[8px] bg-[#DEE2E7] relative overflow-visible group">
      {/* Progress bar */}
      <div
        className="flex items-center justify-center h-full bg-[#64748b] rounded-md text-white font-bold text-[16px] transition-all duration-300"
        style={{ width: `${percentage}%` }}
      >
        {/* Centered percentage */}
        <span className="absolute left-1/2 transform -translate-x-1/2 flex items-center gap-1">
          <MdElectricBolt />
          {currentEnergyNumber}
        </span>
      </div>

      {/* Battery tip */}
      <div className="w-[7px] h-[20px] bg-[#e0e3e8] absolute right-[-8px] top-[4px] rounded-sm border-2 border-[#c3c8cf]"></div>

      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-[35px] left-1/2 transform -translate-x-1/2 bg-white text-gray-600 text-[14px] p-1 border border-[#c3c8cf] rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-2 whitespace-nowrap">
          <MdElectricBolt size={16} />
          <span className="font-semibold">
            {currentEnergyNumber} MWh / {maxEnergyNumber} MWh
          </span>
        </div>
      )}
    </div>
  );
};

export default Battery;
